import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100vw;
  height: 100vh;

  background-color: white;

  padding: ${({ theme }) => theme.spacings.abs32}px;
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;

  border-radius: 16px;
`;
